<div class="popup" v-if="show">
    <div class="popup-content card">
        <div class="card-body center-text">
            <p class="card-text">{{ message }}</p>
            <button @click="handleOKClick" class="btn btn-danger">Back</button>
        </div>
    </div>
</div>
